import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-automatch-selfpick-art',
  templateUrl: './automatch-selfpick-art.component.html',
  styleUrls: ['./automatch-selfpick-art.component.scss']
})
export class AutomatchSelfpickArtComponent {
  @Input() automatchButtonArtUrl: string;
  @Input() automatchButtonArt: string;
  @Input() selfPickButtonArtUrl: string;
  @Input() selfPickButtonArt: string;
  @Input() s3BucketUrl: string;

  @Output() fileUpload = new EventEmitter<{file: File, type: string}>();
  @Output() imageRemoved = new EventEmitter<string>();

  onFileUpload(file: File, type: string) {
    this.fileUpload.emit({ file, type });
  }
}
